import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Checkmark18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.5676 3.49021L6.54022 15.1009L0.969666 9.53033L2.03033 8.46967L6.45977 12.8991L15.4324 2.50978L16.5676 3.49021Z'
      fill='currentColor'
    />
  </Svg>
);

Checkmark18.displayName = 'Checkmark18';
export default Checkmark18;
